// Notificacoes do sistema: a do painel aberto (mensagem nova enquanto a aba nao
// esta na frente) e o push, que chega mesmo com o app fechado. No iPhone so
// funcionam com o site adicionado a Tela de Inicio (iOS 16.4+) e sempre pelo
// service worker, entao ele e o caminho principal aqui.
import { frontendURL, conversationUrl } from 'dashboard/helper/URLHelper';
import { registerSubscription } from 'dashboard/helper/pushHelper';

const PREVIEW_LENGTH = 140;
const ICON = '/brand-assets/redhosting-thumbnail.png';

export const browserNotificationsSupported = () => 'Notification' in window;

export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const isStandaloneApp = () =>
  window.navigator.standalone === true ||
  window.matchMedia('(display-mode: standalone)').matches;

// No iPhone fora da Tela de Inicio a Apple nao libera notificacao nenhuma.
export const needsHomeScreenForNotifications = () =>
  isIOS() && !isStandaloneApp();

// Safari antigo so aceita callback; os atuais devolvem Promise.
export const requestNotificationPermission = () =>
  new Promise(resolve => {
    const result = Notification.requestPermission(resolve);
    if (result?.then) result.then(resolve);
  });

export const canShowBrowserNotification = () =>
  browserNotificationsSupported() && Notification.permission === 'granted';

// Pede permissao e inscreve este aparelho no push do Chatwoot.
export const enableNotifications = async () => {
  const permission = await requestNotificationPermission();
  if (permission === 'granted') registerSubscription();
  return permission;
};

const show = async (title, options) => {
  const registration =
    'serviceWorker' in navigator
      ? await navigator.serviceWorker.getRegistration()
      : null;
  if (registration) {
    registration.showNotification(title, options);
    return;
  }
  const notification = new Notification(title, options);
  notification.onclick = () => {
    window.focus();
    if (options.data?.url) window.location.assign(options.data.url);
    notification.close();
  };
};

// A etiqueta e a mesma do push da conversa: se os dois chegarem, um substitui o outro.
export const showBrowserNotification = message => {
  if (!canShowBrowserNotification()) return;

  const text = (message.content || '').replace(/\s+/g, ' ').trim();
  show(message.sender?.name || 'RedHosting', {
    body: text.slice(0, PREVIEW_LENGTH) || '📎',
    icon: ICON,
    tag: `conversation-${message.conversation_id}`,
    renotify: true,
    data: {
      url: frontendURL(
        conversationUrl({
          accountId: message.account_id,
          id: message.conversation_id,
        })
      ),
    },
  });
};

// Confirma na hora que o sistema esta mostrando as notificacoes.
export const showTestNotification = (title, body) => {
  if (!canShowBrowserNotification()) return;
  show(title, { body, icon: ICON, tag: 'redhosting-test' });
};
